import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-flipping-logo',
  templateUrl: './flipping-logo.component.html',
  styleUrls: ['./flipping-logo.component.scss'],
  animations: [
    trigger('flipState', [
      state('front', style({ transform: 'rotateY(0)' })),
      state('back', style({ transform: 'rotateY(180deg)' })),
      transition('back => front', animate('1000ms ease-out')),
      transition('front => back', animate('1000ms ease-in'))
    ]),
  ]
})
export class FlippingLogoComponent {

  @Input() height: string = '100%';
  @Input() width: string = '100%';
  @Input() frontImage: string;
  @Input() frontImageHeight: string;
  @Input() frontImageWidth: string;
  @Input() backImage: string;
  @Input() backImageHeight: string;
  @Input() backImageWidth: string;
  @Input() bgColor: string = 'transparent';
  flipState: string = 'front';
  clickable:boolean = false;

  constructor() {}

  @Input() set onClick(onClick: Function){
    this.clickable = true;
    this._onClick = onClick; 
  };

  get onClick(){
    return this._onClick
  }

  ngAfterViewInit() {
    if(this.backImage)
      setInterval(() => { this._flipLogo(); }, 7000);
  }

  getBackfaceLogoStyle = () => this.flipState == 'front'
  ?{ 'z-index': '0', 'transition-property': 'z-index', 'transition-delay': '.4s'}
  :{ 'z-index': '10001', 'transition-property': 'z-index', 'transition-delay': '.7s'};

  private _onClick: Function;

  private _flipLogo = () => this.flipState = (this.flipState === 'front' ? 'back' : 'front');

 
}
